import { Navigate, useLocation } from "react-router-dom";
import type { ReactNode } from "react";
import { LoadingLayout } from "@/layouts";
import { useSession } from "@/auth/useSession";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { ready, accessToken, configured } = useSession();
  const location = useLocation();

  if (!ready) {
    return <LoadingLayout message="Restoring session…" />;
  }

  if (!configured) {
    return (
      <LoadingLayout message="Configure VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to sign in." />
    );
  }

  if (!accessToken) {
    return (
      <Navigate to="/auth/sign-in" replace state={{ from: location.pathname }} />
    );
  }

  return children;
}
